import lang from '../../../../lib/language';
import { NullableString } from '../../../../lib/util/types';

import styles from '../../HotGappers.module.scss';

type Props = {
  isEnabled: boolean;
  timerValueAsString: NullableString;
};

const MarketRegularHoursTimer = ({ isEnabled, timerValueAsString }: Props): JSX.Element => {
  if (!isEnabled) return <></>;

  return (
    <div className={styles.timerArea}>
      <span className={styles.label}>{lang.gappersHottestMoversOpenTimer()}</span>
      <span className={styles.timer}>{timerValueAsString}</span>
    </div>
  );
};

export default MarketRegularHoursTimer;
